define('drops/modalPopup/modalPopup',[
    'jquery',
    'lq/drop',
    'lq/modalblur'
], function ($, Drop, ModalBlur) {
    'use strict';

    var minimumZIndexOfModalLayer = 6000;
    var minimumZIndexOfPopup = 6001;

    var defaults = {
        data: {
            size: { x: 200, y: 80 },
            color: "rgba(204, 51, 51, 1)",
            hasColor: true,
            opacity: 100,
            lightBoxOpacity: 100,
            hasBlur: false,
            blur: 0,
            scrolling: 'auto',
            boxShadow: {
                enabled: false,
                color: 'rgb(136, 136, 136)',
                x: 0,
                y: 0,
                blur: 0,
                spread: 0
            },
            roundedCorners: {
                enabled: false,
                leftTopRadius: 0,
                rightTopRadius: 0,
                rightBottomRadius: 0,
                leftBottomRadius: 0
            }
        }
    };

    var ModalPopup = function (options) {
        Drop.call(this, $('<div />'), defaults, options);

        this.renderDropShadow();
        this.renderBackground();

        if (this.data.centered) {
            // We set the ModalLayer height explicitly based on the scroll height of the
            // ScrollContainer, but this changes with the window resize
            this.resizer = ModalBlur.updateModalLayerHeight.bind(this);
            $(window).resize(this.resizer);
        }
    };

    Drop.extend(ModalPopup, Drop);

    ModalPopup.typeName = 'ModalPopup';

    ModalPopup.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
        this.centerInsideParent();
        this.applyZIndex();
        this.applyOpacity();
        this.applyRoundedCorners();
    };

    ModalPopup.prototype.applyZIndex = function () {
        this.$element.css('zIndex', minimumZIndexOfPopup + this.data.zIndex);
    };

    ModalPopup.prototype.applyOpacity = function () {
        this.$element.css('opacity', this.data.opacity/100);
    };

    ModalPopup.prototype.postRender = function () {
        Drop.prototype.postRender.apply(this, arguments);
        this.renderModalLayer(this.data);
    };

    ModalPopup.prototype.applyRoundedCorners = function () {
        if (this.data.roundedCorners && this.data.roundedCorners.enabled) {
            var radLT = this.data.roundedCorners.leftTopRadius ? (this.data.roundedCorners.leftTopRadius + 0) + 'px' : '0px';
            var radRT = this.data.roundedCorners.rightTopRadius ? (this.data.roundedCorners.rightTopRadius + 0) + 'px' : '0px';
            var radRB = this.data.roundedCorners.rightBottomRadius ? (this.data.roundedCorners.rightBottomRadius + 0) + 'px' : '0px';
            var radLB = this.data.roundedCorners.leftBottomRadius ? (this.data.roundedCorners.leftBottomRadius + 0) + 'px' : '0px';
            this.$element.css({
                borderRadius: radLT + ' ' + radRT + ' ' + radRB + ' ' + radLB
            });
        } else {
            this.$element.css({ borderRadius: '' });
        }
    };

    ModalPopup.prototype.centerInsideParent = function () {
        if (!this.data.centered)
            return;

        if ((this.data.top !== null && this.data.top !== undefined) || (this.data.bottom !== null && this.data.bottom !== undefined)) {
            this.$element
                .css({
                    left: null,
                    right: null,
                    margin: 'auto'
                });

            if (!this.renderInBackground) {
                // the position in this.data is relative to the root drop, but when rendering we have
                // to position the modal relative to the browser window because we're using 'position: fixed'

                if (this.data.top !== null)
                    this.$element.css('top', this.data.top + (this.getRootDrop().data.top || 0));

                if (this.data.bottom !== null)
                    this.$element.css('bottom', this.data.bottom + (this.getRootDrop().data.bottom || 0));
            }
        } else {
            this.$element
                .css({
                    top: this.getVerticalCenterPosition() + 'px',
                    bottom: null,
                    left: null,
                    right: null,
                    margin: 'auto'
                });
        }
    };

    ModalPopup.prototype.getHorizontalCenterPosition = function() {
        var totalWidth = $(window).width();
        return ((totalWidth - this.data.size.x) / 2) >= 0 ? (totalWidth - this.data.size.x) / 2 : 0;
    };

    ModalPopup.prototype.getVerticalCenterPosition = function () {
        var totalHeight = $(window).height();
        return ((totalHeight - this.data.size.y) / 2) >= 0 ? (totalHeight - this.data.size.y) / 2 : 0;
    };

    ModalPopup.prototype.renderBackground = function () {
        if (this.data.hasColor)
            this.$element.css({ backgroundColor: this.data.color });
        else
            this.$element.css({ backgroundColor: "transparent" });
    };

    ModalPopup.prototype.renderDropShadow = function () {
        if (this.data.boxShadow && this.data.boxShadow.enabled) {
            var color = this.data.boxShadow.color ? this.data.boxShadow.color : 'rgb(136, 136, 136)';
            var x = this.data.boxShadow.x ? (this.data.boxShadow.x + 0) + 'px' : '0px';
            var y = this.data.boxShadow.y ? (this.data.boxShadow.y + 0) + 'px' : '0px';
            var blur = this.data.boxShadow.blur ? (this.data.boxShadow.blur + 0) + 'px' : '0px';
            var spread = this.data.boxShadow.spread ? (this.data.boxShadow.spread + 0) + 'px' : '0px';
            this.$element
                .css({
                    boxShadow:
                        color + ' ' +
                        x + ' ' +
                        y + ' ' +
                        blur + ' ' +
                        spread
                    });
        } else {
            this.$element.css({ boxShadow: '' });
        }
    };

    ModalPopup.prototype.show = function () {
        Drop.prototype.show.call(this);

        if (this.$scrollContainer) {
            this.$scrollContainer.css({
                height: '100%',
                overflow: this.isScrollable() ? 'auto' : ''
            });
            this.$scrollContainer.show();
        }
        if (this.$modalLayer) {
            ModalBlur.updateModalLayerHeight.call(this);
            this.$modalLayer.show();
        }
        ModalBlur.applyBlur.call(this);

        this.addBackgroundClickHandler();
    };

    ModalPopup.prototype.hide = function () {
        this.removeBackgroundClickHandler();

        Drop.prototype.hide.call(this);

        var self = this;
        setTimeout(function () {
            if (self.$modalLayer) {
                self.$modalLayer.hide();
            }
        });
        if (this.$scrollContainer) {
            this.$scrollContainer.hide();
        }
        if (this.data.hasBlur) {
            ModalBlur.setBlurValue.call(this, 0);
        }
    };

    ModalPopup.prototype.addBackgroundClickHandler = function () {
        this.removeBackgroundClickHandler();
        var self = this, openTime = Date.now();
        this.backgroundClickHandler = function (event) {
            if (Date.now() - openTime < 50 || self.$element[0] === event.target || $.contains(self.$element[0], event.target))
                return;

            // e.g. the invisible input element that is used to upload files
            if (!$(event.target).is(':visible'))
                return;

            self.removeBackgroundClickHandler();

            if (self.data.closeWhenBackgroundClicked)
                self.hide();

            self.triggerEventIfEnabled('backgroundClicked');
        };
        this.piping.$app.on('click touchstart', this.backgroundClickHandler);
    };

    ModalPopup.prototype.removeBackgroundClickHandler = function () {
        if (this.backgroundClickHandler) {
            this.piping.$app.off('click touchstart', this.backgroundClickHandler);
            this.backgroundClickHandler = null;
        }
    };

    ModalPopup.prototype.renderModalLayer = function () {
        if (this.data.hasLightBox || this.data.centered) {
            this.$scrollContainer = this.$scrollContainer || $('<div />').hide();
            this.$modalLayer = this.$modalLayer || $('<div />').appendTo(this.$scrollContainer);

            this.applyModalLayerLayout();

            if (this.data.centered) {
                this.$scrollContainer.appendTo(this.piping.$app);
            } else if (this.data.toBrowser) {
                this.$scrollContainer.appendTo(this.piping.$actionWrapper);
            } else {
                this.$scrollContainer.appendTo(this.rootDrop.$element);
            }
            this.$scrollContainer.append(this.$element);
        }
    };

    ModalPopup.prototype.applyModalLayerLayout = function () {
        if (this.data.hasLightBox || this.data.centered) {
            this.$scrollContainer
                .css({
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: minimumZIndexOfModalLayer + this.data.zIndex,
                    overflowY: 'hidden'
                });

            this.$modalLayer
                .css({
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: minimumZIndexOfModalLayer + this.data.zIndex - 1,
                    backgroundColor: this.data.hasLightBox ? this.data.lightBoxColor : 'rgba(0, 0, 0, 0)',
                    opacity: this.data.lightBoxOpacity / 100
                });
        }
    };

    ModalPopup.prototype.render = function ($element) {
        var self = this;
        return this.createAndRenderDrops($element)
            .then(function () {
                if (self.isVisible()) {
                    self.show();
                }
            });
    };

    ModalPopup.prototype.isScrollable = function () {
        return this.data.centered && this.$scrollContainer;
    };

    ModalPopup.prototype.unsubscribeEventHandlers = function () {
        this.removeBackgroundClickHandler();

        if (this.resizer) {
            $(window).off('resize', this.resizer);
        }

        if (this.$scrollContainer) {
            this.$scrollContainer.remove();
        }
    };

    return ModalPopup;
});

